import { getStyleguideClass } from './createSelectors';

const withClassNames = <T extends object>(object: T, prefix = ''): T =>
  Object.fromEntries(
    Object.entries(object).map(([k, v]) => [k, getStyleguideClass(`${prefix}${v}`)]),
  ) as T;

export const HOTSPOT = withClassNames({
  BeaconWrapper: 'h-beacon-wrapper',
  Beacon: 'h-beacon',
  Arrow: 'h-arrow',
  Wrapper: 'h-wrapper',
  Container: 'h-container',
  Body: 'h-body',
});

export const TOUR_STEP = withClassNames({
  Arrow: 't-arrow',
  Wrapper: 't-wrapper',
  Container: 't-container',
  Body: 't-body',
  BackdropContainer: 't-backdrop-container',
  BackdropWrapper: 't-backdrop-wrapper',
});

export const OVERLAY = withClassNames({
  Container: 'modalV2--container',
  Backdrop: 'modalV2--backdrop',
});

export const DISMISS = withClassNames({
  Wrapper: 'dismiss-wrapper',
  SVG: 'dismiss-svg',
});

export const COPYTEXT = withClassNames({
  Wrapper: 'copy-text-wrapper',
  SVG: 'copy-text-svg',
});
